import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * The redesign renamed the Code Security pages. Old links - bookmarks, the CLI's printed
 * URLs, Agent Atlas deep links, GitHub PR comments - keep working: each old path forwards
 * to its new home and keeps its query string.
 *
 *   /sast/dashboard          -> /sast/overview
 *   /sast/history            -> /sast/repositories
 *   /sast/scanner            -> /sast/repositories?scan=new   (opens the scan panel)
 *   /sast/scanner/:scanId    -> /sast/scans/:scanId
 */
export const RedirectKeepQuery = ({ to }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
};

export const RedirectToNewScan = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('scan', 'new');
  return <Navigate to={`/sast/repositories?${params.toString()}`} replace />;
};

export const RedirectScan = () => {
  const { scanId } = useParams();
  const { search } = useLocation();
  return <Navigate to={`/sast/scans/${encodeURIComponent(scanId)}${search}`} replace />;
};
